(function() {
  function initMetalColorSelector() {
    const containers = document.querySelectorAll('.metal-color-selector-container');
    if (containers.length === 0) return;

    containers.forEach(container => {
      const swatches = container.querySelectorAll('.metal-swatch-item');
      const activeLabel = container.querySelector('.metal-color-active');

      if (!swatches.length || !activeLabel) return;

      // Click handlers for metal swatches
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          const label = this.dataset.label;
          
          // Remove active class from all swatches
          swatches.forEach(s => s.classList.remove('active'));
          
          // Add active class to clicked swatch
          this.classList.add('active');
          
          // Update label text
          if (activeLabel && label) {
            activeLabel.textContent = label;
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetalColorSelector);
  } else {
    initMetalColorSelector();
  }

  // Re-initialize for theme editor
  document.addEventListener('shopify:section:load', initMetalColorSelector);
})();

